// extracted by css-extract-rspack-plugin
export default {"ApplyButton":"o3ysZ"};